import _ from "lodash";
import {
  ACTIONS_DELETE_DEVIATION_FILE_SUCCESS,
  ACTIONS_FETCH_PROJECT_FUNCTIONS,
  ACTIONS_FETCH_PROJECT_FUNCTIONS_ERROR,
  ACTIONS_FETCH_PROJECT_FUNCTIONS_SUCCESS,
  ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS,
  ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_ERROR,
  ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_SUCCESS,
  ACTIONS_SELECT_PROJECT,
  ACTIONS_SELECT_PROJECT_FUNCTION,
  ACTIONS_UPLOAD_DEVIATION_SUCCESS,
  ACTION_UPDATE,
  ACTION_UPDATE_ERROR,
  ACTION_UPDATE_SUCCESS,
  ACTION_UPDATE_ALL,
  ACTION_UPDATE_ALL_ERROR,
  ACTION_UPDATE_ALL_SUCCESS,
  APP_FETCH_ABOUT_CURRENT_USER_SUCCESS,
  ACTIONS_SET_PENDING_STEP_INDEX,
  ACTIONS_SUBMIT_PENDING_SUCCESS,
  ACTIONS_SUBMIT_PENDING,
  ACTIONS_SUBMIT_PENDING_ERROR,
  ACTIONS_SET_PENDING_SORT_PROPERTY,
  ACTIONS_SET_APPROVED_SORT_PROPERTY,
  ACTION_CHANGE_COMPLIANCE_ERROR,
  ACTION_CHANGE_COMPLIANCE_SUCCESS,
  ACTION_CHANGE_COMPLIANCE,
  ACTIONS_ONE_TIME_DEVIATION_SUCCESS,
  ACTIONS_PROCEDURE_COMMENT_SAVE,
  ACTIONS_PROCEDURE_COMMENT_SAVE_SUCCESS,
  ACTIONS_PROCEDURE_COMMENT_SAVE_ERROR
} from "../reduxActions/Types";
import { updateAction, saveActionProcedureComment } from "../reduxActions/ActionsActions";
import createTypography from "@material-ui/core/styles/createTypography";

const INITIAL_STATE = {
  applicabilityOptions: [],
  applicabilityOptionsObject: {},
  actionGroups: null,
  projectActionGroups: [],
  fetchingActions: false,
  submittingActions: false,
  fectchingActionsError: null,
  tempDeviationFiles: {},
  editableApprovedActions: {},
  projectFunctions: [],
  projectFunctionsMine: [],
  projectFunctionsReadOnly: [],
  selectedProject: null,
  selectedProjectFunctionDetails: null,
  fetchingProjectFunctions: false,
  fetchingProjectFunctionDetails: false,
  selectedProjectFunctionDetailsUpdates: {},
  actionsUpdatingStatus: {},
  submittingPendingActions: false,
  pendingSortProperty: 'procedureSdn',
  pendingSortReverse: true,
  approvedSortProperty: 'procedureSdn',
  approvedSortReverse: true,
  procedureComments: [],
};


const updateActionForClient = action => {

  let approvalType = "Standard";
  let approvalTypeColor = "#d9d9d9";

  if (action.activeOneTimeDeviation) {
    approvalType = "One-Time Deviation";
    approvalTypeColor = "#ffdf5a";

  } else if (action.applicabilityId === "NO" && action.categoryName === "IWPP") {
    approvalType = "IWPP Deviation";
    approvalTypeColor = "#feb8b8";
  }

  return { ...action, approvalType, approvalTypeColor };
}

const updateSelectedProjectFunctionDetailsForClient = selectedProjectFunctionDetails => {

  let canRestartandcancel = false;
  if (selectedProjectFunctionDetails.masterWorkflowSteps.length > 0) {
    const filteredSteps = selectedProjectFunctionDetails.masterWorkflowSteps.filter(masterWorkflowStepfilter => !masterWorkflowStepfilter.iwpp);
    canRestartandcancel = filteredSteps.some(masterWorkflowStep => masterWorkflowStep.isCurrentUser)

    if (!canRestartandcancel) {
      filteredSteps.map((masterWorkflowStep) => {
        const temp = masterWorkflowStep.proxy.some((proxyItem) => {
          return proxyItem.isCurrentUser
        })
        if (temp) {
          canRestartandcancel = true;
        }
      })
    }
  }

  const pendingActions = selectedProjectFunctionDetails.pendingActions.map(action => updateActionForClient(action));
  const approvedActions = selectedProjectFunctionDetails.approvedActions.map(action => updateActionForClient(action));
  return { ...selectedProjectFunctionDetails, pendingActions, approvedActions, canRestartandcancel };
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APP_FETCH_ABOUT_CURRENT_USER_SUCCESS:
      let applicabilityOptions = action.payload.applicabilityOptions.map(
        ({ id, name, sortOrder, description, requiresDeviationReasoning }) => ({
          value: id,
          title: name,
          sortOrder,
          requiresDeviationReasoning,
          description,
        })
      );
      applicabilityOptions = _.sortBy(applicabilityOptions, "sortOrder");
      const applicabilityOptionsObject = _.mapValues(
        _.keyBy(applicabilityOptions, "value")
      );

      return {
        ...state,
        applicabilityOptions,
        applicabilityOptionsObject,
      };
    case ACTIONS_UPLOAD_DEVIATION_SUCCESS: {
      let deviationFiles = state.tempDeviationFiles[action.payload.procedureId]
        ? [
          ...state.tempDeviationFiles[action.payload.procedureId],
          ...action.payload.files,
        ]
        : [...action.payload.files];
      const tempDeviationFiles = { ...state.tempDeviationFiles };
      tempDeviationFiles[action.payload.procedureId] = deviationFiles;
      return { ...state, tempDeviationFiles };
    }
    case ACTIONS_DELETE_DEVIATION_FILE_SUCCESS: {
      let procedureIdTmpDeviationFiles = state.tempDeviationFiles[
        action.payload.procedureId
      ]
        ? state.tempDeviationFiles[action.payload.procedureId]
        : [];
      procedureIdTmpDeviationFiles = procedureIdTmpDeviationFiles.filter(
        (file) => file.id !== action.payload.deviationFile.id
      );
      const tempDeviationFiles = { ...state.tempDeviationFiles };
      tempDeviationFiles[
        action.payload.procedureId
      ] = procedureIdTmpDeviationFiles;
      const actionGroups = [...state.actionGroups];

      let actionIndex = null;
      let procedureIndex = null;

      for (let i = 0; i < state.actionGroups.length; i++) {
        procedureIndex = _.findIndex(state.actionGroups[i].actions, [
          "procedureId",
          action.payload.procedureId,
        ]);
        if (procedureIndex !== -1) {
          actionIndex = i;
          break;
        }
      }

      if (actionIndex) {
        actionGroups[actionIndex].actions[
          procedureIndex
        ].attachments = actionGroups[actionIndex].actions[
          procedureIndex
        ].attachments.filter(
          (file) => file.id !== action.payload.deviationFile.id
        );
      }

      return { ...state, tempDeviationFiles, actionGroups };
    }
    case ACTIONS_FETCH_PROJECT_FUNCTIONS_ERROR:
      return { ...state, fetchingProjectFunctions: false };
    case ACTIONS_FETCH_PROJECT_FUNCTIONS:
      return { ...state, fetchingProjectFunctions: true };
    case ACTIONS_FETCH_PROJECT_FUNCTIONS_SUCCESS:

      let projectFunctionsMine = action.payload.filter(project => _.find(project.functions, { isAssigned: true }));
      let projectFunctionsReadOnly = action.payload.filter(project => !_.find(project.functions, { isAssigned: true }));

      // Clear selected project if it's no longer in the user's assigned list (e.g., after user switch/impersonation)
      let selectedProject = state.selectedProject;
      if (selectedProject && !projectFunctionsMine.find(p => p.id === selectedProject.id)) {
        selectedProject = null;
      }

      return {
        ...state,
        projectFunctions: action.payload,
        projectFunctionsMine,
        projectFunctionsReadOnly,
        selectedProject,
        selectedProjectFunctionDetails: selectedProject ? state.selectedProjectFunctionDetails : null,
        fetchingProjectFunctions: false,
      };

    case ACTION_CHANGE_COMPLIANCE_ERROR:
    case ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_ERROR:
      return { ...state, fetchingProjectFunctionDetails: false };
    case ACTION_CHANGE_COMPLIANCE:
    case ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS:
      return { ...state, fetchingProjectFunctionDetails: true };
    case ACTION_UPDATE_SUCCESS:
      {
        let { updatedAction, projectFunctionDetails } = action.payload
        updatedAction = updateActionForClient(updatedAction);

        const selectedProjectFunctionDetailsUpdates = state.selectedProjectFunctionDetailsUpdates;
        selectedProjectFunctionDetailsUpdates[updatedAction.procedureId] = null;
        const { selectedProjectFunctionDetails } = state;
        const { pendingActions, approvedActions } = updateSelectedProjectFunctionDetailsForClient(projectFunctionDetails);


        return {
          ...state,
          selectedProjectFunctionDetails: { ...selectedProjectFunctionDetails, pendingActions, approvedActions },
          selectedProjectFunctionDetailsUpdates
        };

        // let p = pendingActions.filter((item) => {
        //   return item.procedureId == updatedAction.procedureId
        // })

      }
    case ACTIONS_ONE_TIME_DEVIATION_SUCCESS:
    case ACTION_CHANGE_COMPLIANCE_SUCCESS: {
      const { selectedProjectFunctionDetails } = state;
      const { pendingActions, approvedActions } = updateSelectedProjectFunctionDetailsForClient(action.payload);
      return {
        ...state,
        selectedProjectFunctionDetails: { ...selectedProjectFunctionDetails, pendingActions, approvedActions },
        fetchingProjectFunctionDetails: false,
        selectedProjectFunctionDetailsUpdates: {}
      };
    }
    case ACTIONS_FETCH_PROJECT_FUNCTION_DETAILS_SUCCESS: {

      let currentStepIndex = action.payload.masterWorkflowSteps.findIndex(step => step.isCurrentUser || step.isProxy);
      currentStepIndex = currentStepIndex === -1 ? 0 : currentStepIndex;
      const selectedProjectFunctionDetails = updateSelectedProjectFunctionDetailsForClient(action.payload);
      return {
        ...state,
        selectedProjectFunctionDetails: { ...selectedProjectFunctionDetails, currentStepIndex },
        fetchingProjectFunctionDetails: false,
        selectedProjectFunctionDetailsUpdates: {}
      };
    }
    case ACTIONS_SUBMIT_PENDING_ERROR:
      return { ...state, submittingPendingActions: false };
    case ACTIONS_SUBMIT_PENDING:
      return { ...state, submittingPendingActions: true };
    case ACTIONS_SUBMIT_PENDING_SUCCESS: {
      const selectedProjectFunctionDetails = updateSelectedProjectFunctionDetailsForClient(action.payload);
      return {
        ...state,
        selectedProjectFunctionDetails: { ...selectedProjectFunctionDetails, currentStepIndex: state.selectedProjectFunctionDetails.currentStepIndex },
        submittingPendingActions: false,
        selectedProjectFunctionDetailsUpdates: {}
      };
    }
    case ACTIONS_SELECT_PROJECT: {
      return {
        ...state,
        selectedProject: action.payload && action.payload.id ? action.payload : null,
        selectedProjectFunctionDetails: null,
        selectedProjectFunctionDetailsUpdates: {}
      };
    }
    case ACTIONS_SELECT_PROJECT_FUNCTION: {
      if (!state.selectedProject) {
        return state;
      }

      const selectedFunction = (state.selectedProject.functions || []).find(
        (projectFunction) => projectFunction && action.payload && projectFunction.id === action.payload.id
      );

      if (!selectedFunction) {
        return state;
      }

      const selectedProject = {
        ...state.selectedProject,
        selectedFunction,
      };

      return { ...state, selectedProject };
    }


    case ACTION_UPDATE:

      const selectedProjectFunctionDetailsUpdates = state.selectedProjectFunctionDetailsUpdates;
      selectedProjectFunctionDetailsUpdates[action.payload.procedureId] = action.payload.fieldsToUpdate;
      return {
        ...state,
        selectedProjectFunctionDetailsUpdates
      };
    case ACTION_UPDATE_ERROR: {

      return {
        ...state,
      };
    }

    case ACTION_UPDATE_ALL:
      return {
        ...state,
      };
    case ACTION_UPDATE_ERROR: {

      return {
        ...state,
      };
    }

    case ACTIONS_SET_PENDING_STEP_INDEX: {
      return {
        ...state,
        selectedProjectFunctionDetails: { ...state.selectedProjectFunctionDetails, currentStepIndex: action.payload }
      };
    }

    case ACTIONS_SET_PENDING_SORT_PROPERTY: {
      return {
        ...state,
        pendingSortProperty: action.payload,
        pendingSortReverse: (action.payload === state.pendingSortProperty && !state.pendingSortReverse)
      };
    }
    case ACTIONS_SET_APPROVED_SORT_PROPERTY: {
      return {
        ...state,
        approvedSortProperty: action.payload,
        approvedSortReverse: (action.payload === state.approvedSortProperty && !state.approvedSortReverse)
      };
    }
    case ACTIONS_PROCEDURE_COMMENT_SAVE_SUCCESS: {
      return {
        ...state,
        procedureComments: action.payload,
      };
    }
    case ACTIONS_PROCEDURE_COMMENT_SAVE_ERROR:
      return { ...state };
    case 'RESET_ALL_REDUX_STATE':
      return INITIAL_STATE;
    default:
      return state;
  }
};
